import { useTheme } from '../contexts/ThemeContext';

export default function SlateLogo({ size = 20, className = '', forceDark, forceLight }) {
  const { theme } = useTheme();
  let src;
  if (forceDark) src = '/slate-logo-dark.png';
  else if (forceLight) src = '/slate-logo-light.png';
  else src = theme === 'dark' ? '/slate-logo-dark.png' : '/slate-logo-light.png';
  return (
    <img
      src={src}
      alt="Slate"
      width={size}
      height={size}
      className={`object-contain ${className}`}
      data-testid="slate-logo"
    />
  );
}
